module.exports = __webpack_public_path__ + "static/media/DS_Membership_Pic2.da70922b.png";